<template>
    <tender_custom_payment :tender="tender"></tender_custom_payment>
</template>

<script>

import tender_custom_payment from "./tender_custom_payment.vue";

export default {
    name: "tender_request",
    props : {
        tender : {
            type : Object,
            required : true
        }
    },
    
    components : {
        tender_custom_payment
    }
}
</script>


<style scoped>

</style>